export enum NextLessonButtonType {
  NEXT_LESSON = 'next_lesson',
  NEXT_UNIT = 'next_unit',
  UNIT_INDEX = "unit_index"
}



// WEBPACK FOOTER //
// ./ts/app/shared/types/NextButtonActionType.ts